import React, { useState, useEffect } from 'react'
import Slider from 'react-slick';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import "../../Styles/App.css"
export default function Section7() {
  const [time, setTime] = useState(13 * 3600 + 24 * 60 + 48);

  useEffect(() => {
    if (time <= 0) return;

    const timer = setInterval(() => {
      setTime((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [time]);

  const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };
  const players = [
    {
      id: 1,
      bid: "Current bid",
      name: "Maximus Dribbleton",
      thumbnail: "/assets/player/player1.svg",
      title: "Patterfly Studio",
      price: "21.6 ETH",
      image: "/assets/icon/ethereum (1) 1.svg"
    },
    {
      id: 2,
      bid: "Current bid",
      name: "Leo Passini",
      thumbnail: "/assets/player/player2.svg",
      title: "PhotoLution",
      price: "19.2 ETH",
      image: "/assets/icon/ethereum (1) 1.svg"
    },
    {
      id: 3,
      bid: "Current bid",
      name: "Wen Yan",
      thumbnail: "/assets/player/player3.svg",
      title: "MX Clone",
      price: "17.5 ETH",
      image: "/assets/icon/ethereum (1) 1.svg"
    },
    {
      id: 4,
      bid: "Current bid",
      name: "Athens",
      thumbnail: "/assets/player/player4.svg",
      title: "The Artificial",
      price: "15.9 ETH",
      image: "/assets/icon/ethereum (1) 1.svg"
    }
  ];
  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    <div
      {...props}
      className="absolute transform top-[50%] -translate-y-[-50%] left-0 z-10 w-7 h-7"
    >
      <div className="cursor-pointer hover:bg-white text-white hover:text-black rounded-full p-[2px] h-8 w-8 border border-white">
        <div className='flex justify-center items-center w-full h-full rounded-full'>
          <FontAwesomeIcon icon={faChevronLeft} className=" font-bold cursor-pointer" />
        </div>
      </div>
    </div>
  );
  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <div
      {...props}
      className="absolute transform top-[50%] -translate-y-[-50%] right-0 w-7 h-7 "
    >
      <div className="cursor-pointer hover:bg-white text-white hover:text-black border border-white rounded-full p-[2px] h-8 w-8">
        <div className='flex justify-center items-center w-full h-full rounded-full'>
          <FontAwesomeIcon icon={faChevronRight} className=" font-bold cursor-pointer" />
        </div>
      </div>
    </div>
  );
  const settingsSuccess = {
    infinite: true,
    speed: 500,
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <div className='min-h-screen py-10 bg-[#0E081B]/30'>
      <div className='pb-5 relative'>
        <p className='text-white font-medium text-2xl lg:text-4xl capitalize 2xl:text-5xl text-center'>Scout Tomorrow’s Legends</p>
        <p className='text-center text-white mt-4'>Explore GoalDex’s player profiles, powered by AI and precision performance insights. The future of football starts here!</p>
      </div>
      <div className='w-[90%] mx-auto mt-5 lg:mt-10'>
        <div className='flex justify-between'>
          <p className='text-white uppercase font-bold text-xs lg:text-xl'>TOP COLLECTION</p>
        </div>
        <Slider {...settingsSuccess}>
          {players.map((collection) => (
            <div key={collection.id} className="mt-10">
              <div className='mx-auto p-[0.7px] overflow-hidden relative 2xl:w-[70%] lg:w-[90%] rounded-3xl'>
                <div className='Card-gradient-bg animate-spin-slow'></div>
                <div className='Card-gradient-bg animate-spin-slow'></div>
                <div className=' rounded-3xl py-5 px-5 bg-gradient-to-r from-[#0e0c15] via-[#120d20] to-[#141633]'>
                  <div className='flex justify-between'>
                    <div>
                      <p>{collection.bid}</p>
                      <p className='flex justify-start items-center gap-1'><img src={collection.image}></img>&nbsp;{collection.price}</p>
                    </div>
                    <div>
                      <button className='cursor-pointer text-white rounded-full py-1 bg-gradient-to-r from-[#2F1073] via-[#5C1FE2] to-[#2F1073] px-5'>Place bid</button>
                    </div>
                  </div>
                  <div className='flex justify-center'>
                    <img src={collection.thumbnail}></img>
                  </div>
                  <div className='flex justify-between items-center gap-5 mt-3 '>
                    <p className='font-bold text-xl uppercase truncate'>{collection.name}</p>
                    <p className='text-sm text-nowrap'>ENDS &nbsp;{formatTime(time)}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  )
}
